import apiClient from '../../../../utils/apiClient';

export const api = {
  listStrategies: async (universe) => {
    const res = await apiClient.get('/strategy-analytics/strategies', {
      params: { universe },
    });
    return res.data;
  },

  getOverview: async (universe, { startDate, endDate } = {}) => {
    const params = { universe };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/overview', { params });
    return res.data;
  },

  getLeaderboard: async (universe, { startDate, endDate } = {}) => {
    const params = { universe };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/leaderboard', { params });
    return res.data;
  },

  getCorrelation: async (universe, { startDate, endDate } = {}) => {
    const params = { universe };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/correlation', { params });
    return res.data;
  },

  getStrategyNav: async (strategyId, universe, { startDate, endDate } = {}) => {
    const params = { universe };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/strategies/' + strategyId + '/nav', { params });
    return res.data;
  },

  getStrategyBasket: async (strategyId, universe, week) => {
    const res = await apiClient.get('/strategy-analytics/strategies/' + strategyId + '/basket', {
      params: { universe, week },
    });
    return res.data;
  },

  getStrategyBaskets: async (strategyId, universe) => {
    const res = await apiClient.get('/strategy-analytics/strategies/' + strategyId + '/baskets', {
      params: { universe },
    });
    return res.data;
  },

  getScripOhlcv: async (scrip, { startDate, endDate } = {}) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/scrips/' + encodeURIComponent(scrip) + '/ohlcv', { params });
    return res.data;
  },

  getPortfolioCurrent: async (universe) => {
    const res = await apiClient.get('/strategy-analytics/portfolio/current', {
      params: { universe },
    });
    return res.data;
  },

  getPortfolioSelections: async (universe) => {
    const res = await apiClient.get('/strategy-analytics/portfolio/selections', {
      params: { universe },
    });
    return res.data;
  },

  getPortfolioNav: async (universe, { startDate, endDate } = {}) => {
    const params = { universe };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await apiClient.get('/strategy-analytics/portfolio/nav', { params });
    return res.data;
  },

  setPortfolioHoldings: async (universe, scrips, snapshotDate) => {
    const res = await apiClient.post('/strategy-analytics/portfolio/holdings', {
      universe,
      scrips,
      snapshot_date: snapshotDate ?? null,
    });
    return res.data;
  },
};
